import React from "react";
import Header from "@/sections/Header";
import Hero from "@/sections/Hero";
import TrustStrip from "@/sections/TrustStrip";
import Services from "@/sections/Services";
import WhyUs from "@/sections/WhyUs";
import About from "@/sections/About";
import Faq from "@/sections/Faq";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";

export default function Landing() {
  return (
    <div className="bg-cream text-ink" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <WhyUs />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
